module.exports = __webpack_public_path__ + "static/media/update.0ae84278.svg";